import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
import { getResultData } from '../redux/apiData';
import { clearModalState, setModalInitialized, updateModalOpenState } from '../redux/modal';
import { colorPalette, CUBIC_TIMING, fadeIn, fadeInUp, fadeOutDown } from '../styles/styleGuide';
import { GridWrapper } from '../styles/gridElements';
import { hex2rgb, darken } from '../styles/utils';
import ContentLoader from './shared/ui/ContentLoader';
import ModalComponentLoader from './ModalComponentLoader';
import ButtonClose from './shared/buttons/ButtonClose';
import isWhite from '../services/isWhite';
import get from 'lodash.get';
import { resetHtmlStyleForModal, setHtmlStyleForModal, getScrollbarWidth } from '@/processes/modalHelpers';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    modalIsOpen: state.modal.modalIsOpen,
    color: state.modal.color,
    modalConfig: state.modal.modalConfig,
    showLoader: state.modal.showLoader,
    initialized: state.modal.initialized,
    styling: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {})
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      dispatch(updateModalOpenState(false));
      dispatch(clearModalState());
    },
    closeOnLocationChange: function closeOnLocationChange() {
      dispatch(updateModalOpenState(false));
      dispatch(clearModalState());
    },
    setInitialized: function setInitialized() {
      dispatch(setModalInitialized());
    }
  };
};
var Modal = /*#__PURE__*/function (_Component) {
  function Modal(props) {
    var _this;
    _classCallCheck(this, Modal);
    _this = _callSuper(this, Modal, [props]);
    _defineProperty(_this, "scrollEl", null);
    _defineProperty(_this, "handleModalClose", function (evt) {
      if (evt && evt.type === 'click' || evt && evt.type === 'keydown' && evt.keyCode === 27) {
        var _this$props$modalConf, _this$props$modalConf2;
        _this.props.onClose();
        (_this$props$modalConf = (_this$props$modalConf2 = _this.props.modalConfig).onClose) === null || _this$props$modalConf === void 0 || _this$props$modalConf.call(_this$props$modalConf2);
      }
    });
    _this.state = {};
    return _this;
  }
  _inherits(Modal, _Component);
  return _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.handleModalClose, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.closeOnLocationChange();
      window.removeEventListener('keydown', this.handleModalClose, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        modalIsOpen = _this$props.modalIsOpen,
        closeOnLocationChange = _this$props.closeOnLocationChange,
        initialized = _this$props.initialized,
        setInitialized = _this$props.setInitialized;
      var previousPathname = this.state.previousPathname;

      // reset scoll position, only if the modal was just opened
      if (!initialized) {
        if (this.scrollEl) {
          this.scrollEl.scrollTop = 0;
        }
        setInitialized();
      }
      if (modalIsOpen && !prevProps.modalIsOpen) {
        setHtmlStyleForModal(true, getScrollbarWidth());
      }
      if (!modalIsOpen && prevProps.modalIsOpen) {
        resetHtmlStyleForModal();
      }
      if (previousPathname !== window.location.pathname) {
        closeOnLocationChange();
        this.setState({
          previousPathname: window.location.pathname
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        match = _this$props2.match,
        modalIsOpen = _this$props2.modalIsOpen,
        color = _this$props2.color,
        showLoader = _this$props2.showLoader,
        modalConfig = _this$props2.modalConfig,
        renderWidth = _this$props2.renderWidth,
        styling = _this$props2.styling;
      var env = match.params.env;
      var buttonColor = env === 'open' ? styling.button ? styling.button : colorPalette.beige : colorPalette.blue;
      return __jsx(ModalBackground, {
        isOpen: modalIsOpen,
        color: color,
        "data-id": "components_Modal_ModalBackground"
      }, __jsx(ScrollContainer, {
        ref: function ref(scrollEl) {
          _this2.scrollEl = scrollEl;
        },
        className: "scrollable",
        "data-id": "components_Modal_ScrollContainer"
      }, modalConfig && modalConfig.type && __jsx(ModalGridWrapper, {
        "data-e2e-modalcomponent-wrapper": true,
        "data-id": "components_Modal_ModalGridWrapper"
      }, showLoader && __jsx(ContentLoader, {
        "data-id": "components_Modal_ContentLoader"
      }), !showLoader && (!modalConfig.componentProps || !modalConfig.componentProps.hideCloseButtons) && __jsx(ButtonContainer, {
        color: color,
        "data-id": "components_Modal_ButtonContainer"
      }, __jsx(ButtonClose, {
        clickHandler: this.handleModalClose,
        color: isWhite(color) ? buttonColor : color ? darken(color, 8) : '',
        colorText: isWhite(color),
        renderWidth: renderWidth,
        "data-id": "components_Modal_ButtonClose"
      })), __jsx(AnimationWrapper, {
        "data-e2e-modalcomponent": modalConfig.type,
        doneLoading: !showLoader,
        "data-id": "components_Modal_AnimationWrapper"
      }, __jsx(ModalComponentLoader, {
        type: modalConfig.type,
        modalConfig: modalConfig,
        renderWidth: renderWidth,
        "data-id": "components_Modal_ModalComponentLoader"
      })), !showLoader && (!modalConfig.componentProps || !modalConfig.componentProps.hideCloseButtons) && __jsx(ButtonContainer, {
        color: color,
        second: 1,
        "data-id": "components_Modal_ButtonContainer"
      }, __jsx(ButtonClose, {
        clickHandler: this.handleModalClose,
        color: isWhite(color) ? buttonColor : color ? darken(color, 8) : '',
        colorText: isWhite(color),
        renderWidth: renderWidth,
        "data-id": "components_Modal_ButtonClose"
      })))));
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(Modal));
var ModalBackground = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  position: fixed;\n  z-index: 100;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  transition: background 0.4s ease-in;\n  background: ", ";\n  visibility: ", ";\n  animation: ", ";\n  animation-fill-mode: forwards;\n"])), function (props) {
  var _props$color;
  if (isWhite(props.color)) {
    return 'rgba(255, 255, 255, 1)';
  }
  return hex2rgb((_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : colorPalette.beige, 0.9);
}, function (props) {
  return props.isOpen ? 'visible' : 'hidden';
}, function (props) {
  return props.isOpen ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                    ", " 0.5s\n                  "])), fadeIn) : css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                    ", " 0.5s\n                  "])), fadeOutDown);
});
var ModalGridWrapper = styled(GridWrapper)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  flex-direction: row;\n  justify-content: center;\n  box-sizing: border-box;\n  padding: 40rem 20rem;\n"])));
var ScrollContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  overflow: scroll;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n  width: 100%;\n"])));
var ButtonContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  margin-bottom: ", ";\n  width: 100%;\n  margin-top: ", ";\n\n  &:before {\n    content: '';\n    display: flex;\n    flex-grow: 1;\n    width: 100%;\n  }\n"])), function (props) {
  return props.second ? 0 : '20rem';
}, function (props) {
  return props.second ? '20rem' : 0;
});
var AnimationWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  opacity: 0;\n  animation: ", ";\n  animation-delay: 0.5s;\n  animation-fill-mode: forwards;\n"])), function (props) {
  return props.doneLoading ? css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n                    ", " 0.6s ", "\n                  "])), fadeInUp, CUBIC_TIMING) : '';
});